module.exports = __webpack_public_path__ + "static/mps-es-3344eca503468bf89256a314357dd16f.jpg";